
















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbRole, TbShopAccount } from '@/http';
import { dialogPanel,NumberKeyboard,logoutPanel } from "@/components"
import dayjs from 'dayjs';
import { Toast,Dialog } from 'vant';
var md5 = require("js-md5");
@Component({ 
    components: {
        dialogPanel,NumberKeyboard,logoutPanel
    },
})
export default class info extends Vue {
   
    public $refs: {
    };

    /**分类列表 */
    classList=[]

    /**查询项 */
    searchValue={
        roleid:"",
        nameorphone:"",
        shopid:"",
        skip:0,
        count:10,
    }
    /**状态下拉 */
    showStatusPopover = false;
    roleOptions=[]

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType=1;

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

    /**新增员工弹窗 */
    show=false;
    title="新增员工";
    isEdit = false;
    form:any={
        jobNumber:"",
        name:"",
        phone:"",
        pwd:"",
        roleId:"",
        isForbidden:false,
        appAuth:"1",
        isAllowLogin:false,
    };
    isloading = false;
   
    showRolePopover = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;
    deletId="";

    isDeleting = false;
    
    

    created() {
        
    }
    
    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getRoleList();
    }

    /**上架状态 */
    get getRoleStatus(){
        let str = ""
        if(this.searchValue.roleid){
            str = this.roleOptions.findIndex(v=>v.id==this.searchValue.roleid)>-1?this.roleOptions.find(v=>v.id==this.searchValue.roleid).name:'';
        }else{
            str ='全部角色'
        }
        return str;
    }
    get  roleName(){
        let str = ""
        str = this.roleOptions.findIndex(v=>v.id==this.form.roleId)>-1?this.roleOptions.find(v=>v.id==this.form.roleId).name:'';
        return str;
    }

    /**获取角色下拉 */
    async getRoleList(){
        let res= await TbRole.GetTbRoleDropList({
            shopid:this.userInfo.shopId,
        })
        this.roleOptions = res;
    }


    /**选择状态 */
    async changeStatusAll(){
        this.searchValue.roleid = "";
        this.showStatusPopover = false;
        await this.getList();
    }
    async changeStatusXL(item){
        this.searchValue.roleid = item.id;
        this.showStatusPopover = false;
        await this.getList();
    }
   
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbShopAccount.GetTbShopAccountList(Object.assign({},this.searchValue,{
                needSubShop:false,
                shopid:this.userInfo.shopId
            }))
            this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            
            }
    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=30;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbShopAccount.GetTbShopAccountList(Object.assign({},this.searchValue,{
                needSubShop:false,
                shopid:this.userInfo.shopId
            }))
        this.list = res.items;
        this.total  = res.totalCount;
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            roleid:"",
            nameorphone:"",
            shopid:"",
            skip:0,
            count:10,
        }
        this.startDate = "";
        this.endDate = "";
        this.getList();
    }
   
    addProduct(){
        this.$router.push("/pad/product/addProduct")
    }
    viewDetail(item){
        this.$router.push("/pad/product/viewProduct?id="+item.id);
    }

    closeFun(){
        this.show = false;
        this.showRolePopover = false;
        this.resetForm();
    }
    resetForm(){
        this.form = {
            jobNumber:"",
            name:"",
            phone:"",
            pwd:"",
            roleId:"",
            isForbidden:false,
            appAuth:"1",
            isAllowLogin:false,
        }
    }
    addStaff(){
        this.isEdit= false; 
        this.title = "新增员工";
        this.show = true;
    }
    changeRoleXL(item){
        this.form.roleId = item.id;
        this.showRolePopover = false;
    }
    changeForbidden(val){
        if(this.isEdit&&this.form.isPrimaryAccount) return;
        this.form.isForbidden = val;
    }
    finishNum(val,type){
        switch (type) {
            case 1:
                this.form.jobNumber = val;
                break;
            case 2:
                this.form.phone = val;
                break;
        
            default:
                break;
        }
    }
    async editRow(item){
        if(!this.hasAuth('803')){
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor:'#0491A7'
                }).then(() => {
                
                });
            return;
        }
       let res = await TbShopAccount.GetTbShopAccountById({
        id:item.id
       });
       this.form = res;
       this.isEdit= true;
       this.title = "编辑员工";
       this.show = true; 
    }
    async confirmSave(){
        if(this.isloading) return;
        if(!this.form.name){
            Toast('请输入姓名');
            return;
        }
        if(!this.form.jobNumber){
            Toast('请输入工号');
            return;
        }
        if(this.form.phone&&this.form.phone.length!=11){
            Toast('请输入11位手机号');
            return;
        }
        if(!this.form.roleId){
            Toast('请选择角色');
            return;
        }
        if(this.form.pwd&&this.form.pwd.trim().length==0){
            Toast('密码不能为空');
            return;
        }
        if(this.form.pwd&&this.form.pwd.length<8){
            Toast('密码至少8位');
            return;
        }
        if(this.form.pwd&&!/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{8,16}$/.test(this.form.pwd)){
            Toast('密码必须同时包含数字，大小写字母');
            return;
        }
        this.isloading = true;
        /**新增 */
        if(!this.isEdit){
            try {
                let obj = Object.assign({},this.form,
                    {
                        pwd:this.form.pwd?md5(this.form.pwd):md5('Hft123456'),
                        shopId:this.userInfo.shopId
                    }
                )
                let res = await TbShopAccount.PostTbShopAccount(obj);
                await this.getList();
                Toast("新增成功");
                this.isloading = false;
                this.closeFun();
            } catch (error) {
                this.isloading = false;
            }
        }else{
            try {
                let obj = this.form.pwd?Object.assign({},this.form,
                    {
                        pwd:md5(this.form.pwd),
                    }
                ):this.form;
                let res = await TbShopAccount.UpdateTbShopAccount(obj);
                await this.getList();
                Toast("修改成功");
                this.isloading = false;
                this.closeFun();
            } catch (error) {
                this.isloading = false;
            }
        }
        
    }
    deleteRow(item){
        if(!this.hasAuth('804')){
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor:'#0491A7'
                }).then(() => {
                
                });
            return;
        }
        this.tipTitle = "操作提醒";
        this.tipText = `确定删除员工“${item.name}”吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.deletId = item.id;
        this.tipShow = true;
    }

    /**提示弹窗 */
    async tipConfirm(){
        if(this.tipType==1){
            this.cDFun(this.deletId)
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    async cDFun(id){
        if(this.isDeleting) return;
        this.isDeleting = true;
        try {
            let res = await TbShopAccount.DeleteTbShopAccount(id);
            Toast("删除成功")
            await this.getList();
            this.isDeleting = false;
        } catch (error) {
            this.isDeleting = false;
        }
        
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/staff/components/info.vue